import { HashRouter, Routes, Route } from 'react-router-dom';
import { Home } from '@/pages/Home';
import { ROUTE_PATHS } from '@/lib/index';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path={ROUTE_PATHS.HOME} element={<Home />} />
      </Routes>
    </HashRouter>
  );
}
